import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ProjectForm from '../project.form';

export default function AddProject(props) {
  const { langId } = useSelector((state) => state.language);
  return <ProjectForm {...props} langId={langId} />;
}
